export const CYCLE_TYPE = {
  INITIALIZATION: "INITIALIZATION",
  RENEWAL: "RENEWAL",
};
